import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index'

var eraValues = {
  abbreviated: ['BC', 'AD'],
  narrow: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
}

var quarterValues = {
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  narrow: ['1', '2', '3', '4'],
  wide: ['ika-1 quarter', 'ika-2 quarter', 'ika-3 quarter', 'ika-4 na quarter']
}

var formattingQuarterValues = quarterValues

var monthValues = {
  abbreviated: [
    'Ene',
    'Peb',
    'Mar',
    'Abr',
    'May',
    'Hun',
    'Hul',
    'Ago',
    'Set',
    'Okt',
    'Nob',
    'Dis'
  ],
  narrow: [
    'E',
    'P',
    'M',
    'A',
    'M',
    'Hun',
    'Hul',
    'Ago',
    'Set',
    'Okt',
    'Nob',
    'Dis'
  ],
  wide: [
    'Enero',
    'Pebrero',
    'Marso',
    'Abril',
    'Mayo',
    'Hunyo',
    'Hulyo',
    'Agosto',
    'Setyembre',
    'Oktubre',
    'Nobyembre',
    'Disyembre'
  ]
}

var formattingMonthValues = {
  abbreviated: [
    'Ene',
    'Peb',
    'Mar',
    'Abr',
    'May',
    'Hun',
    'Hul',
    'Ago',
    'Set',
    'Okt',
    'Nob',
    'Dis'
  ],
  narrow: [
    'Ene',
    'Peb',
    'Mar',
    'Abr',
    'May',
    'Hun',
    'Hul',
    'Ago',
    'Set',
    'Okt',
    'Nob',
    'Dis'
  ],
  wide: [
    'Enero',
    'Pebrero',
    'Marso',
    'Abril',
    'Mayo',
    'Hunyo',
    'Hulyo',
    'Agosto',
    'Setyembre',
    'Oktubre',
    'Nobyembre',
    'Disyembre'
  ]
}

var dayValues = {
  abbreviated: ['Lin', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'],
  narrow: ['Lin', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'],
  short: ['Li', 'Lu', 'Ma', 'Mi', 'Hu', 'Bi', 'Sa'],
  wide: [
    'Linggo',
    'Lunes',
    'Martes',
    'Miyerkules',
    'Huwebes',
    'Biyernes',
    'Sabado'
  ]
}

var formattingDayValues = dayValues

var dayPeriodValues = {
  abbreviated: {
    afternoon: 'tanghali',
    am: 'AM',
    evening: 'hapon',
    midnight: 'hatinggabi',
    morning: 'umaga',
    night: 'gabi',
    noon: 'tanghaling-tapat',
    pm: 'PM'
  },
  narrow: {
    afternoon: 'tanghali',
    am: 'AM',
    evening: 'gabi',
    midnight: 'hatinggabi',
    morning: 'umaga',
    night: 'gabi',
    noon: 'tanghaling-tapat',
    pm: 'PM'
  },
  wide: {
    afternoon: 'tanghali',
    am: 'AM',
    evening: 'hapon',
    midnight: 'hatinggabi',
    morning: 'umaga',
    night: 'gabi',
    noon: 'tanghaling-tapat',
    pm: 'PM'
  }
}

var formattingDayPeriodValues = {
  abbreviated: {
    afternoon: 'tanghali',
    am: 'AM',
    evening: 'ng hapon',
    midnight: 'hatinggabi',
    morning: 'nang umaga',
    night: 'gabi',
    noon: 'tanghaling-tapat',
    pm: 'PM'
  },
  narrow: {
    afternoon: 'sa hapon',
    am: 'am',
    evening: 'sa gabi',
    midnight: 'hatinggabi',
    morning: 'umaga',
    night: 'gabi',
    noon: 'tanghaling-tapat',
    pm: 'pm'
  },
  wide: {
    afternoon: 'tanghali',
    am: 'AM',
    evening: 'ng hapon',
    midnight: 'hatinggabi',
    morning: 'nang umaga',
    night: 'ng gabi',
    noon: 'tanghaling-tapat',
    pm: 'PM'
  }
}

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  return dirtyNumber
}

var localize = {
  ordinalNumber: ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues,
    argumentCallback: function(quarter) {
      return Number(quarter) - 1
    }
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayValues,
    defaultFormattingWidth: 'wide'
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
}

export default localize
